import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import type { Translatable } from "app/pages/sales-intelligence/types";

import { StyledDescription, StyledHeaderTextsWrap, StyledTitle } from "./styles";

type ModalHeaderContentProps = {
    title: Translatable;
    description?: Translatable;
};

const ModalHeaderContent = (props: ModalHeaderContentProps) => {
    const { title, description } = props;

    return (
        <StyledHeaderTextsWrap>
            <I18n
                data-automation="title-text"
                element={StyledTitle}
                translatable={title}
            />
            {description ? <I18n
                    data-automation="description-text"
                    element={StyledDescription}
                    translatable={description}
                /> : null}
        </StyledHeaderTextsWrap>
    );
};

export default ModalHeaderContent;
